export default __webpack_public_path__ + "static/media/myCoursesLogo.0d8aa982.png";